import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useStyle } from "./style";
import { IError } from "itsf-ui-common";
import { StancerPaymentIframe } from "@common/PaymentIframe";
import { ChoiceDisplay, EChoiceDisplayValues } from "@common/ChoiceDisplay";
import { SavedPaymentMethodCardList } from "@common/SavedPaymentMethodCardList/SavedPaymentMethodCardList";
import { ISimplePaymentMethodCard } from "@common/SimplePaymentMethodCardList";
import { Badge, Box, Grid } from "@mui/material";

interface IParams {
    validatePaymentApiRoute: string;
    iframePaymentApiRoute: string;
    payWithSavedCardApiRoute(cardId: string): string;
    paymentMethodCardList: ISimplePaymentMethodCard[];
    successCallback(): void;
    errorCallback?(error: IError): void;
}

export const PaymentChoice = (props: IParams) => {
    const {
        validatePaymentApiRoute,
        iframePaymentApiRoute,
        payWithSavedCardApiRoute,
        paymentMethodCardList,
        successCallback,
        errorCallback,
    } = props;

    const { classes } = useStyle();

    const [selectedChoice, setSelectedChoice] = useState<EChoiceDisplayValues>(
        paymentMethodCardList.length ? EChoiceDisplayValues.FIRST : EChoiceDisplayValues.SECOND
    );
    const { t } = useTranslation("summary");

    return (
        <ChoiceDisplay
            options={[
                {
                    label: (
                        <Grid alignItems="center" container>
                            <Grid item>
                                <Box paddingRight={3}>
                                    <span>{t("payWithSavedCard")}</span>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Badge
                                    anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
                                    badgeContent={paymentMethodCardList.length}
                                    className={classes.countingBadge}
                                    max={99}
                                    showZero
                                />
                            </Grid>
                        </Grid>
                    ),
                    value: EChoiceDisplayValues.FIRST,
                    disabled: !paymentMethodCardList.length,
                    component: (
                        <SavedPaymentMethodCardList
                            payWithSavedCardApiRoute={payWithSavedCardApiRoute}
                            paymentCreditCardList={paymentMethodCardList}
                            successCallback={successCallback}
                            validatePaymentApiRoute={validatePaymentApiRoute}
                        />
                    ),
                },
                {
                    label: t("payWithAnotherCard"),
                    value: EChoiceDisplayValues.SECOND,
                    component: (
                        <Box paddingY={3}>
                            <StancerPaymentIframe
                                errorCallback={errorCallback}
                                iframePaymentApiRoute={iframePaymentApiRoute}
                                successCallback={successCallback}
                                validatePaymentApiRoute={validatePaymentApiRoute}
                            />
                        </Box>
                    ),
                },
            ]}
            selectedChoice={selectedChoice}
            setSelectedChoice={setSelectedChoice}
        />
    );
};
